import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, TextButton } from '@dataplace.ai/ui-components/atoms'
import styled from 'styled-components'
import { Description, ImageWrapper, BottomWrapper } from './DownloadModal.styles'

export type DownloadStatus = 'success' | 'error' | null;

interface PdfState {
  loading: boolean;
  status: DownloadStatus;
}

interface SavingState {
  loading: boolean;
  error?: string | null;
  value: unknown;
}

interface PdfInfoViewProps {
  pdfState: PdfState;
  savingState: SavingState;
  canBeSave: boolean;
  isEdit: boolean;
  handleClick: (redirect: boolean) => void;
}
const StyledBottomWrapper = styled(BottomWrapper)`
  margin-top: 1rem;
  justify-content: space-between;
`

const PdfInfoView: React.FC<PdfInfoViewProps> = ({
  pdfState,
  savingState,
  canBeSave,
  isEdit,
  handleClick,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Description>
        {pdfState?.status === 'error'
          ? t('placeme.pdf_generation_infoview1_error')
          : t('placeme.new_pdf_generation_infoview1')}
      </Description>
      <Description>
        {canBeSave && !isEdit && savingState?.value && !savingState?.error
          ? t('placeme.save_infoview1')
          : t('placeme.save_infoview1_error')}
      </Description>
      <ImageWrapper>
        <img
          alt='pdf info view'
          src='assets/images/pdfInfoView.svg'
        />
      </ImageWrapper>
      <StyledBottomWrapper>
        <TextButton
          onClick={() => handleClick(false)}
          type='button'
        >
          {t('generic.close')}
        </TextButton>
        <Button
          margin='0 0 0 20px'
          onClick={() => handleClick(true)}
          type='button'
        >
          {t('placeme.redirect_to_analyses_and_reports')}
        </Button>
      </StyledBottomWrapper>
    </>
  )
}

export default PdfInfoView
